//----------------------------------------------------Library
import React, { Suspense, useState } from 'react';
import Alert from "@material-ui/lab/Alert";
import { createTheme } from '@material-ui/core/styles'
import { CircularProgress, Collapse, Container, Grid, Link, responsiveFontSizes, Snackbar, Typography } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
//----------------------------------------------------redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux"
import * as ProcessActions from "../Actions/ProcessActions";
//----------------------------------------------------Component
import StepOne from '../Components/StepOne';
import StepTwo from '../Components/StepTwo';
import HeaderBar from './HeaderBar';
import StepThree from '../Components/StepThree';
import StepFour from '../Components/stepFour';

const SNACKBAR_INIT_VALUE = {
  open: false,
  type: "error",
  message: "",
  duration: 6000,
};

const OverLayStyle = {
  position: 'absolute',
  width: '100vw',
  height: '100vh',
  display: 'grid',
  gridTemplateColumns: 'max-content',
  gridTemplateRows: 'max-content max-content max-content',
  gridGap: '10px',
  backgroundColor: '#1d1d1dbf',
  placeContent: 'center',
  zIndex: '8',
  top: '0',
  bottom: '0',
  left: '0',
  right: '0',
};

const Body = (props) => {
  const [snackbar, setSnackBar] = useState(SNACKBAR_INIT_VALUE);
  const theme = responsiveFontSizes(
    createTheme({
      palette: {
        primary: {
          main: props.primaryColor,
        },
      },
    })
  );

  theme.typography.h3 = { fontSize: "3.2rem" };
  theme.typography.button = { fontSize: "2.2rem" };

  const handleSnackbarClose = () => setSnackBar(SNACKBAR_INIT_VALUE);

  const handleSnackbarOpen = (snackbar) => {
    if (snackbar === null) {
      return handleSnackbarClose();
    } else {
      setSnackBar(snackbar);
    }
  }


  const renderSteps = () => {
    const { step } = props;

    const stepOneProps = {
      openSnackbar: handleSnackbarOpen,
    }

    const stepTwoProps = {
      openSnackbar: handleSnackbarOpen,
    }

    const stepThreeProps = {
      openSnackbar: handleSnackbarOpen,
    }

    const stepFourProps = {
      openSnackbar: handleSnackbarOpen,
    }

    return (<>
      <Collapse in={step === 1}>
        <StepOne {...stepOneProps} />
      </Collapse>
      <Collapse in={step === 2}>
        <StepTwo {...stepTwoProps} />
      </Collapse>
      <Collapse in={step === 3}>
        <StepThree {...stepThreeProps} />
      </Collapse>
      <Collapse in={step === 4}>
        <StepFour {...stepFourProps} />
      </Collapse>
    </>);
  }

  const renderBody = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Suspense fallback={<Typography variant="h4">Loading...</Typography>}>
            {renderSteps()}
          </Suspense>
        </Grid>

        <Snackbar
          open={snackbar.open}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={snackbar.duration || 6000}
          onClose={handleSnackbarClose}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbar.type} variant="filled"><Typography variant="body2">{snackbar.message}</Typography></Alert>
        </Snackbar>
      </Grid>
    )
  }

  return (
    <ThemeProvider theme={theme}>
      <div>
        <HeaderBar />
        <div style={{ height: "20px" }}></div>

        <Grid container justifyContent="center" alignItems="center" spacing={3}>
          <Grid item lg={5} md={7} sm={12} xs={12}>
            <Container>
              {renderBody()}
            </Container>
          </Grid>
        </Grid>

        <Snackbar
          open={snackbar.open}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={snackbar.duration || 6000}
          onClose={props.actions.closeSnackbar}
        >
          <Alert onClose={props.actions.closeSnackbar} severity={snackbar.type} variant="filled"><Typography variant="body2">{snackbar.message}</Typography></Alert>
        </Snackbar>

        {!props.overlayOpen ? null :
          <div style={OverLayStyle}>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content', placeContent: 'center' }}>
              <CircularProgress style={{ color: '#327cb7' }} size={100} />
            </div>
            <Typography variant="h4" style={{ color: '#ffffff' }}>Please do not <strong>refresh</strong> this page</Typography>
            <Link href="#" style={{ textAlign: "center", color: '#fff' }} onClick={() => window.location.reload()}>Cancel</Link>
          </div>
        }

      </div>
    </ThemeProvider>
  )
};

Body.propTypes = {};

const mapStateToProps = ({ process }) => ({
  loading: process.loading,
  step: process.step,
  primaryColor: process.primaryColor,
  snackbar: process.snackbar,
  overlayOpen: process.overlayOpen,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ProcessActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Body);
